import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
import { Doc } from '../../core/models/document.model';
const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
@Injectable({ providedIn: 'root' })
export class DocService {
  private apiUrls: { [key in 'bank' | 'pgl' | 'smt']: string } = {
    bank: environment.apiBankUrl, 
    pgl: environment.apiPglUrl,
    smt: environment.apiSmtUrl,
  };
  private getBaseUrl(): string {
    const userType = this.getUserType();
    return this.apiUrls[userType??'smt']+'/documents/';
  }
  private getUserType(): 'bank' | 'pgl' | 'smt' {
    const token = localStorage.getItem('x-access-token') || ''; // Fallback to an empty string if null
    if (!token) return 'smt';

    try {
      const decodedToken: any = jwtDecode(token);
      return decodedToken.type as 'bank' | 'pgl' | 'smt';
    } catch (error) {
      console.error('Error decoding token:', error);
      return 'smt';
    }
  } 
    
    constructor(private http: HttpClient) { }
    public docs: Doc[] = [];
    public docs$ = new Subject<Doc[]>();
 

    getDocs(type:string) {
      const baseUrl = this.getBaseUrl();
        this.http.get(`${baseUrl}getdocuments/${type}`).subscribe(
          (docs: Doc[]) => {
            if (docs) {
              this.docs = docs;
              this.emitDocs();
            }
          },
          (error) => {
            console.log(error);
          }
        );
      }
    
      emitDocs() {
        this.docs$.next(this.docs);
      }

      getDocdataById(id: string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
            this.http.get(`${baseUrl}${id}`).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error); 
            }
          );
        });
      }

      create(Doc: Doc, image: File| string) {
        return new Promise((resolve, reject) => {
          let Docdata: Doc | FormData;
          if (typeof image === 'string') {
            Docdata = Doc;
          } else {
            Docdata = new FormData();
            Docdata.append('doc', JSON.stringify(Doc));
            Docdata.append('image', image, Doc._id);
          }
          const baseUrl = this.getBaseUrl();
          this.http.post(`${baseUrl}`, Docdata).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        }); 
      }

      modify(id: string, Doc: Doc, file: File | string) {
        return new Promise((resolve, reject) => {
          let Docdata: Doc | FormData;
          if (typeof file === 'string') {
            //@ts-ignore
            Doc.ficheUrl = file;
            Docdata = Doc;
          } else {
            Docdata = new FormData();
            Docdata.append('doc', JSON.stringify(Doc));
            Docdata.append('image', file, Doc._id);
          }
          const baseUrl = this.getBaseUrl();
          this.http.put(`${baseUrl}${id}`, Docdata).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }
      deleteDocdataById(id: string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.delete(`${baseUrl}${id}`).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }  
    }
